import { Orientation } from '../../../constants/Orientation';
import { MediaType } from '../../../constants/MediaType';
import { assoc, contains, defaultTo, find, pipe, prop, propEq, split, values } from 'ramda';
import { MediaManagerSDKFile, MediaManagerSDKFolder } from '../../media-manager-sdk';
import { getAdapter } from '../../media-manager-sdk/getAdapter';
import { MainSource } from '../../../constants/Source';

// to keep consistency with publicmedia events
export const encodeBiType = (mediaType: MediaType): string => JSON.stringify({ id: mediaType, title: mediaType });

export const encodeBiCategory = (id: string, categories: MediaManagerSDKFolder[]): string =>
  JSON.stringify({
    id,
    title: find<MediaManagerSDKFolder>(propEq('id', id), categories).name,
  });

export const encodeFolderId = ({ orientation = Orientation.All, category = 'all' }) => `${orientation}_${category}`;

type TDecodedUnsplashFolderId = {
  category: string;
  orientation: Orientation;
};

export const decodeUnsplashFolderId = (folderId: string): TDecodedUnsplashFolderId => {
  const [orientation = Orientation.All, category = 'all'] = pipe<string, string, string[]>(
    defaultTo(''),
    split('_'),
  )(folderId);

  return {
    orientation: contains(orientation, values(Orientation)) ? (orientation as Orientation) : Orientation.All,
    category,
  };
};

export const getId = prop('id');

export const importUnsplashItem = (item: MediaManagerSDKFile, mmgrSettings): Promise<MediaManagerSDKFile> => {
  const unsplashAdapter = getAdapter(MainSource.Unsplash, mmgrSettings);
  // Unsplash has no "name", need to set translated name for it
  return unsplashAdapter.items.importToSite(item.id).then(assoc('name', item.name));
};
